'use client'
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faCalendar } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Link from "next/link";
import Style from "@/lib/style";
import Characteristics from "@/lib/programCharacteristics";

type Props = {
  programName: string;
};

export default function Hero(props: Props) {
  const { programName } = props;
  const matchedStyle = Style.find(style => style.title === programName);
  const program = Characteristics.find(p => p.title === programName);

  return (
    <section className="relative mx-auto py-0 px-8 bigscreen-responsive md:px-0 md:py-8">
      <div className="mt-32 xl:mt-10">
        {program && program.titles && (
          program.titles.map((prog, index) => (
            <div key={index}>
              <h1 className="font-thin text-3xl max-w-md md:text-6xl md:px-0"> {`${prog.first}`} <span className="font-bold"> {`${prog.second}`} </span></h1>
              <div className="py-0 mt-0 font-thin max-w-md md:max-w-lg md:px-0 py-6">
                <p className={`${matchedStyle?.colors?.[0].textColor} text-lg uppercase  md:text-2xl`}>{`${prog.connector}`} <span className="font-bold">{`${prog.subtitle}`}</span></p>
                <p className="mt-2" dangerouslySetInnerHTML={{ __html: prog.description }} />
              </div>
              <div className="relative flex gap-6 py-2 text-sm font-bold uppercase md:py-8 md:px-0 md:text-lg">
                <p className={`${matchedStyle?.colors?.[0].textColor}`}><FontAwesomeIcon icon={faCalendar} className="mr-2"/> Duración</p>
                <p>{prog.duration} {prog.durationTitle}</p>
              </div>
            </div>
          ))
        )}
        <div className="flex flex-col text-center gap-4 py-3 pr-20 max-w-sm font-bold text-xs md:text-sm md:flex-row md:max-w-lg md:py-8 md:px-0">
          <Link href='https://wa.me/50662236864' target='_blank' className={`${matchedStyle?.colors?.[0].buttonGradient} text-white rounded-full py-3 px-2 shadow-sm hover:shadow-lg md:text-nowrap md:py-4 md:px-8`}>
            Sacá tu cita personalizada
          </Link>
          <Link href='https://wa.me/50662236864' target='_blank' className="flex justify-center items-center rounded-full py-2 px-2 shadow-sm bg-white border-2 border-[#46EB61] hover:shadow-lg md:py-3.5 md:px-10">
            <FontAwesomeIcon icon={faWhatsapp} className="text-xl mr-3 text-[#46EB61]" />
            Conversemos
          </Link>
        </div>
      </div>
      <div className="xl:absolute xl:top-0 -right-[0px]">
        <div className="hidden xl:block relative">
          {matchedStyle && matchedStyle.images && (
            <div>
              <img src={matchedStyle?.images?.[0].image} alt="Chef" className="relative h-[650px] z-10 rounded-bl-[150px] rounded-xl" />
              <img src={`${matchedStyle?.images?.[0].line}`}   className={`absolute top-[340px] -right-[211px] z-10 h-16 rotate-90 ${(matchedStyle?.images?.[0] as { linePosition?: string }).linePosition || ''}`} alt="Decoration"/>
            </div>
          )}
          <div className="absolute top-16 -left-32 z-10 bg-[#231F20] rounded-bl-[100px] rounded-tr-[100px] py-11 px-8">
            <img src="/images/logos/escudo.svg" className="h-32 w-32 opacity-90" alt="Escudo Amura"/>
          </div>
        </div>
      </div>
      <span className="hidden to-[#feb601]"></span>
    </section>
  );
}